<template>
  <div class="im-set">
    <div class="set-title">提示语设置</div>
    <div class="set-content">
      <span class="label-set">小程序：</span>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
        v-model="miniProgramsText">
      </el-input>
      <div>
        <el-button type="primary" size="mini" @click="setMiniPrograms">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ImSetIng',
  components: {
  },
  props: {
  },
  watch: {
    imSetWinVisible (val) {
      if (val) this.getMiniPrograms()
    }
  },
  computed: {
    ...mapState({
      imSetWinVisible: state => state.imSetWinVisible
    })
  },
  data () {
    return {
      miniProgramsText: ''
    }
  },
  methods: {
    setMiniPrograms () {
      this.$axios.post('/api/im/auth/setHint', { hint_channel: 1, hint_content: this.miniProgramsText }, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          }
        })
    },
    getMiniPrograms () {
      this.$axios.get('/api/im/auth/getHint?hint_channel=1', { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.miniProgramsText = data.data.hint_content
          }
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.im-set {
  display: flex;
  flex-direction: column;
  padding: .2rem;
  gap: .2rem;
}
.set-title {
  text-align: center;
}
.set-content {
  display: flex;
  align-items: center;
  gap: .2rem;
}
.label-set {
  width: 1.6rem;
}
</style>



// WEBPACK FOOTER //
// src/common/im/leftSidebar/ImSetIng.vue